module.exports = __webpack_public_path__ + "media/images/massage/card-mobile@3x-b634fdbe49415012f3c7103e9bc66cf2.jpg";